/* eslint-disable react/destructuring-assignment */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Divider,
} from '@material-ui/core';
import {
  FaListAlt,
} from 'react-icons/fa';
import {
  MdPhotoLibrary,
} from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import Colors from '../../constants/color';
import { LocaisStateReducer, LocaState } from '../../store/ducks/locais/types';
import NavCommon from '../../components/navCommon';
import { requestGetLocais, setCleanLocalById } from '../../store/ducks/locais/actions';
import {
  CardSearch,
  ContainerPagination,
  ContainerFilter,
  ContainerSelect,
  ContainerRow,
  SelectRadius,
  Strong,
  Option,
  ContainerList,
  SizedBox,
  ContainerExt,
} from './styles';
import SearchBar from '../../components/searchBar';
import Container from '../../components/container';
import { useStyles } from '../../constants/styles';
import axiosDefault from '../../services/axiosServicesLocais';
import { CategoryStateReducer } from '../../store/ducks/category/types';
import { requestCategory } from '../../store/ducks/category/actions';
import ItemPlace from '../../components/itemPlace';
import MyLoader from '../../components/placeholderCommon';
import ItemPlaceGrid from '../../components/itemPlaceGrid';
import { Places } from '../../interfaces';
import ButtonIconRounde from '../../components/buttonIconRounded';

const Place = (props: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [page, setPage] = useState<number>(1);
  const [pageSelected, setPageSelected] = useState(1);
  const [dataToPage, setDataToPage] = useState<Array<Places>>([]);
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState<string>('list');
  const [idCodigoLocal, setIdCodigoLocal] = useState<number | null>(null);
  const filter = 'list';
  const { data: categories } = useSelector<RootStateOrAny, CategoryStateReducer>(
    (state) => state.category,
  );

  const {
    data,
    loading,
  } = useSelector<RootStateOrAny, LocaisStateReducer>((state) => state.locais);

  const getData = () => {
    dispatch(requestGetLocais());
    dispatch(requestCategory());
  };

  const paginate = () => {
    const pages: number = data.length / 9;
    setPage(Math.ceil(pages));
    setPageSelected(1);
  };

  const handleChange = (_e: any, _page: number) => {
    const newPage = _page * 9;
    setDataToPage(
      data.filter((_item, index) => index >= newPage - 9 && index < newPage),
    );
    setPageSelected(_page);
  };

  const firtPage = () => {
    const newPage = 1 * 9;
    setDataToPage(data.filter((_item, index) => index >= newPage - 9 && index < newPage));
  };

  useEffect(() => {
    if (search) {
      setDataToPage(data);
    } else {
      handleChange('', pageSelected);
    }
  }, [search]);

  useEffect(() => {
    if (idCodigoLocal === null) {
      firtPage();
    } else {
      setDataToPage(data);
    }
  }, [idCodigoLocal]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    paginate();
  }, [data]);

  useEffect(() => {
    firtPage();
  }, [data]);

  useEffect(() => {
    dispatch(setCleanLocalById());
  }, []);

  async function checkStatus(status: boolean, id: string) {
    if (status) {
      await removeItem(id);
    } else {
      await activeLocal(id);
    }
  }

  const removeItem = async (ids: string) => {
    try {
      await axiosDefault.put(`admin/locais/v1/desativar/${ids}`);

      setDataToPage(dataToPage.map((item) => {
        if (item.idLocal === ids) {
          item.localAtivo = false;
          return item;
        }
        return item;
      }));

      toast.success('Local desativado com sucesso!');
    } catch (error) {
      toast.error('⚠ Não foi possível desativar o local!');
    }
  };

  const activeLocal = async (ids: string) => {
    try {
      await axiosDefault.put(`admin/locais/v1/ativar/${ids}`);
      setDataToPage(dataToPage.map((item) => {
        if (item.idLocal === ids) {
          item.localAtivo = true;
          return item;
        }
        return item;
      }));

      toast.success('Local ativado com sucesso!');
    } catch (error) {
      toast.error('⚠ Não foi possível ativar o local.');
    }
  };

  const handleCategoriSelected = (event: any) => {
    if (event.target.value === '') {
      setIdCodigoLocal(null);
      return;
    }
    setIdCodigoLocal(Number(event.target.value));
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: '', name: 'Locais' },
        ]}
        hasOnChange
        onBack={() => { history.goBack(); }}
        onChange={() => {
          history.push({ pathname: '/cadastrar/locais', state: { edit: false } });
        }}
      />
      <ContainerExt>
        <Container component="main" maxWidth="xl">
          <div className={useStyles().containerLocal}>
            {loading ? (
              <MyLoader />
            ) : (
              <>
                <CardSearch>
                  {!loading && (<SearchBar placeholder="Pesquisar por um local" value={search} setValue={setSearch} />)}
                </CardSearch>
                <Divider style={{ marginTop: 30, marginBottom: 30 }} />
                <ContainerFilter>
                  <ContainerSelect>
                    <Strong>Filtrar por categoria</Strong>
                    <SelectRadius>
                      <select onChange={handleCategoriSelected}>
                        <Option value="">Todos</Option>
                        {categories.map((item) => (
                          <Option value={item.codigo}>{item.nome}</Option>
                        ))}
                      </select>
                    </SelectRadius>
                  </ContainerSelect>
                  <ContainerRow>
                    <ButtonIconRounde
                      color={Colors.ice}
                      icon={<FaListAlt size={18} style={{ color: Colors.grey1 }} />}
                      onPress={() => setTypeFilter('list')}
                    />
                    <SizedBox />
                    <ButtonIconRounde
                      color={Colors.ice}
                      icon={<MdPhotoLibrary size={18} style={{ color: Colors.grey1 }} />}
                      onPress={() => setTypeFilter('grid')}
                    />
                    <SizedBox />
                  </ContainerRow>
                </ContainerFilter>
                <ContainerList key={typeFilter === filter ? 'column' : 'row'}>
                  {!loading && (
                    dataToPage
                      .filter((item: LocaState) => {
                        if (search) {
                          return (
                            (item?.nome || '')
                              .toUpperCase()
                              .indexOf(search.toUpperCase()) !== -1
              || (item?.endereco || '')
                .toUpperCase()
                .indexOf(search.toUpperCase()) !== -1
              || (item?.bairro || '')
                .toUpperCase()
                .indexOf(search.toUpperCase()) !== -1
                          );
                        }
                        return true;
                      }).filter((item: LocaState) => {
                        if (idCodigoLocal === null) {
                          return item;
                        }
                        if (item.codigoCategoriaLocal === idCodigoLocal) {
                          return item;
                        }
                      }).map((item: Places) => {
                        if (typeFilter === filter) {
                          return (
                            <ItemPlace
                              turnsWeek={item.diaSemanaTurnos}
                              isPDV={item.categoriaEscritorio}
                              checked={item.localAtivo}
                              count={item.usuarios.length}
                              name={item.nome}
                              address={item.endereco}
                              contry={item.bairro}
                              numberAddress={item.numeroEndereco}
                              photo={item.urlImagem}
                              onPress={() => checkStatus(item.localAtivo, item.idLocal)}
                              navigation={() => {
                                props.history.push('/cadastrar/locais',
                                  {
                                    idLocal: item.idLocal,
                                    edit: true,
                                    usersProps: item.usuarios,
                                    isPDV: item.categoriaEscritorio,
                                    localName: item.nome,
                                  });
                              }}
                            />
                          );
                        }
                        return (
                          <ItemPlaceGrid
                            isPDV={item.codigoCategoriaLocal === 4}
                            checked={item.localAtivo}
                            count={item.usuarios.length}
                            name={item.nome}
                            address={item.endereco}
                            contry={item.bairro}
                            numberAddress={item.numeroEndereco}
                            photo={item.urlImagem}
                            onPress={() => checkStatus(item.localAtivo, item.idLocal)}
                            navigation={() => {
                              props.history.push('/cadastrar/locais',
                                {
                                  idLocal: item.idLocal,
                                  edit: true,
                                  usersProps: item.usuarios,
                                  isPDV: item.categoriaEscritorio,
                                });
                            }}
                          />
                        );
                      })
                  )}
                </ContainerList>
                {(!loading && search === '' && idCodigoLocal === null) && (
                <ContainerPagination>
                  <Pagination
                    style={{ marginTop: 15, marginBottom: 20 }}
                    count={page}
                    page={pageSelected}
                    onChange={handleChange}
                    color="standard"
                  />
                </ContainerPagination>
                )}
              </>
            )}
          </div>
        </Container>
      </ContainerExt>
    </>
  );
};
export default Place;
